<template>
  <a-card :bordered="false" :bodyStyle='{paddingTop:"0px"}'>
    <a-tabs v-model:activeKey="search.type" @change='tabChange'>
      <a-tab-pane :key="1" tab="经销商"></a-tab-pane>
      <a-tab-pane :key="2" tab="门店"></a-tab-pane>
    </a-tabs>
    <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange'
      layout='inline'>
      <a-form-item :label="search.type == 1 ? '经销商名称':'门店名称'" name='name'>
        <a-input style="width: 270px" v-model:value="search.name" placeholder="请输入关键词进行搜索" />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit'>搜索</a-button>
      </a-form-item>
    </a-form>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='name' :columns='columns' :data-source='list'>
      <template #title_name>
        {{search.type == 1 ? '经销商名称':'门店名称'}}
      </template>
      <template #title_level>
        {{search.type == 1 ? '经销商级别':'门店级别'}}
      </template>
      <template #title_status>
        {{search.type == 1 ? '经销商状态':'门店状态'}}
      </template>
      <template v-slot:action="{ record }">
        <a v-has:antiStockChannelWarnDetail="()=> {$router.push('/antiFleeingGoods/inventoryReport/earlyWarningDetails?type='+search.type+'&num='+record.product_num+'&name='+record.name+'&id='+record.store_id)}"
          href="javascript:;">查看详情</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
      :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
</template>
<script>
  import { ref, onMounted, inject  } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { iscode } from "@/utils/app";
  import useTableSearch from "@/hooks/useTableSearch";
  import { getStockDealer,getStockStore } from "@/api/antiFleeing";
  // 初始化默认筛选项数值
  let defSearch = {
    type:1,
    status: 2,
    page: 1,
    limit: 10,
    name: "",
  };
  export default {
    components: {},
    setup() {
      let columns = [
        {
          dataIndex: "name",
          key: "name",
          slots: { title: 'title_name' }
        },
        {
          dataIndex: "level",
          key: "level",
          slots: { title: 'title_level'}
        },
        {
          title: "所属上级",
          dataIndex: "parent_name",
          key: "parent_name",
        },
        {
          dataIndex: "status_text",
          key: "status_text",
          slots: { title: 'title_status'}
        },
        {
          title: "库存数量",
          dataIndex: "product_num",
          key: "product_num",
        },
        {
          title: "库存状态",
          dataIndex: "product_num_status_text",
          key: "product_num_status_text",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject("$router");
      const {
        pageCurrentChange,
        pageSizeChange,
        search,
        list,
        initData,
        total,
        pageSearchChange,
        listLoading,
      } = useTableSearch({ data: defSearch });
      const tableHoosks = {
        pageCurrentChange,
        pageSizeChange,
        search,
        initData,
        list,
        total,
        pageSearchChange,
        listLoading,
      };
      const tabChange = () =>{
        tableHoosks.initData(search.value.type == 1 ? getStockDealer : getStockStore, search.value);
      }
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        let pageState = getPageState(getRouter().route.path);
        if (pageState) {
          search.value = Object.assign(search.value, pageState);
        }
        tableHoosks.initData(search.value.type == 1 ? getStockDealer : getStockStore, search.value);
      });
      return {
        ...tableHoosks,
        columns,
        tabChange
      };
    },
  };
</script>